/** The scraper's words for a portal that wants an authenticator app set up after the password. */
const SECOND_FACTOR = /second factor/i;

/** CARRIER_SIGN_IN_FAILED's `meta.kind`s that have copy. An unknown one falls back to PASSWORD's. */
const CARRIER_KINDS = ['PASSWORD', 'BLOCKED', 'CODE'];

/**
 * Which copy a carrier sign-in alert gets: by `meta.kind`, and a block that asks for a second
 * factor (AXA's authenticator app) says so when the backend passes the worker's message along
 * (`meta.errorMessage` or `meta.message`).
 */
export const carrierAlertKind = (alert) => {
  const meta = alert.meta || {};
  const kind = CARRIER_KINDS.includes(meta.kind) ? meta.kind : 'PASSWORD';
  if (kind === 'BLOCKED' && SECOND_FACTOR.test(String(meta.errorMessage || meta.message || ''))) {
    return 'BLOCKED_SECOND_FACTOR';
  }
  return kind;
};

/**
 * Locale key for a platform alert banner. A free WhatsApp number gets its own copy so the banner
 * can say "WhatsApp Free"; an older backend sends no `meta.tier` and keeps the generic line.
 * A carrier login that stopped reading is worded by why (carrierAlertKind).
 */
export const platformAlertKey = (alert) => {
  if (alert.code === 'WHATSAPP_DISCONNECTED' && alert.meta?.tier === 'FREE') {
    return `platformAlerts.${alert.code}.FREE_${alert.scope}`;
  }
  if (alert.code === 'CARRIER_SIGN_IN_FAILED') {
    return `platformAlerts.${alert.code}.${carrierAlertKind(alert)}`;
  }
  return `platformAlerts.${alert.code}.${alert.scope}`;
};

export default platformAlertKey;
